// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tree__container___FAMQU {
    overflow: auto;
    display: flex;
    flex-grow: 1;
}

/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */
.Tree__container___FAMQU .rctr--RcTree-list {
    width: 100%;
    padding-right: var(--space-xs);
}

/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */
.Tree__container___FAMQU .rctr--RcTree-node-content-wrapper {
    width: 100%;
}

/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */
.Tree__container___FAMQU .rctr--RcTree-title {
    overflow: visible;
    width: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/ProjectObjects/Tree/Tree.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA,yEAAyE;AACzE;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA,yEAAyE;AACzE;IACI,WAAW;AACf;;AAEA,yEAAyE;AACzE;IACI,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".container {\n    overflow: auto;\n    display: flex;\n    flex-grow: 1;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */\n.container :global(.rctr--RcTree-list) {\n    width: 100%;\n    padding-right: var(--space-xs);\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */\n.container :global(.rctr--RcTree-node-content-wrapper) {\n    width: 100%;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */\n.container :global(.rctr--RcTree-title) {\n    overflow: visible;\n    width: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Tree__container___FAMQU`
};
export default ___CSS_LOADER_EXPORT___;
